import "@/App.css";
import { BrowserRouter, Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";
import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/Home";
import MaLeba from "@/pages/MaLeba";
import News, { ArticlePage } from "@/pages/News";
import Letters, { LetterPage } from "@/pages/Letters";
import Gallery from "@/pages/Gallery";
import PartnerPage from "@/pages/PartnerPage";
import Communication from "@/pages/Communication";
import Contact from "@/pages/Contact";
import Conversation from "@/pages/Conversation";
import Legal from "@/pages/Legal";
import InfoPage from "@/pages/InfoPage";
import Campaign from "@/pages/Campaign";
import Training from "@/pages/Training";
import { Bureau, Documents } from "@/pages/Structure";
import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import { ForgotPassword, ResetPassword } from "@/admin/PasswordReset";
import Dashboard from "@/admin/Dashboard";
import { MessagesList, MessageDetail } from "@/admin/Messages";
import { Applications, GuestbookAdmin, NewsletterAdmin } from "@/admin/Inbox";
import ContentManager from "@/admin/ContentManager";
import { SettingsAdmin, UsersAdmin } from "@/admin/SettingsAdmin";

function NotFound() {
  return (
    <div className="container-x py-24 text-center" data-testid="not-found-page">
      <p className="font-display text-7xl font-bold text-u">404</p>
      <p className="mt-2 text-lg">Page introuvable.</p>
      <Link to="/" className="btn-u mt-6">Retour à l'accueil</Link>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <SiteProvider>
        <AuthProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/ma-leba" element={<MaLeba />} />
              <Route path="/actualites" element={<News />} />
              <Route path="/actualites/:slug" element={<ArticlePage />} />
              <Route path="/lettres" element={<Letters />} />
              <Route path="/lettres/:slug" element={<LetterPage />} />
              <Route path="/galerie" element={<Gallery />} />
              <Route path="/devenir-partenaire" element={<PartnerPage />} />
              <Route path="/communication" element={<Communication />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/conversation/:token" element={<Conversation />} />
              <Route path="/mentions-legales" element={<Legal kind="legal" />} />
              <Route path="/confidentialite" element={<Legal kind="privacy" />} />
              <Route path="/ong" element={<InfoPage pageKey="ong-presentation" />} />
              <Route path="/ong/activites-sante" element={<InfoPage pageKey="ong-health" />} />
              <Route path="/ong/principes" element={<InfoPage pageKey="ong-principles" />} />
              <Route path="/ong/campagnes" element={<Campaign />} />
              <Route path="/ong/partenaires-etrangers" element={<PartnerPage ong />} />
              <Route path="/ong/bureau" element={<Bureau universe="ong" />} />
              <Route path="/ong/documents" element={<Documents universe="ong" />} />
              <Route path="/association" element={<InfoPage pageKey="asso-presentation" />} />
              <Route path="/association/pole-agricole" element={<InfoPage pageKey="asso-agri" />} />
              <Route path="/association/formation" element={<Training />} />
              <Route path="/association/bureau" element={<Bureau universe="association" />} />
              <Route path="/association/documents" element={<Documents universe="association" />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/mot-de-passe-oublie" element={<ForgotPassword />} />
            <Route path="/admin/reinitialiser/:token" element={<ResetPassword />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="messages" element={<MessagesList />} />
              <Route path="messages/:id" element={<MessageDetail />} />
              <Route path="candidatures" element={<Applications />} />
              <Route path="livre-dor" element={<GuestbookAdmin />} />
              <Route path="newsletter" element={<NewsletterAdmin />} />
              <Route path="lettres" element={<ContentManager coll="letters" />} />
              <Route path="articles" element={<ContentManager coll="articles" />} />
              <Route path="galerie" element={<ContentManager coll="media" />} />
              <Route path="documents" element={<ContentManager coll="documents" />} />
              <Route path="bureau" element={<ContentManager coll="members" />} />
              <Route path="parametres" element={<SettingsAdmin />} />
              <Route path="utilisateurs" element={<UsersAdmin />} />
            </Route>
          </Routes>
        </AuthProvider>
      </SiteProvider>
    </BrowserRouter>
  );
}

export default App;
